module.exports = __webpack_public_path__ + "img/sleeve-lc.ffb179ae.png";